import { render, staticRenderFns } from "./ChangeAccountType.vue?vue&type=template&id=386bfa14&scoped=true&"
import script from "./ChangeAccountType.vue?vue&type=script&lang=js&"
export * from "./ChangeAccountType.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAccountType.vue?vue&type=style&index=0&id=386bfa14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386bfa14",
  null
  
)

export default component.exports